<div
  *ngIf="hasEntitlement('VISITORS_ACCOUNTS_HISTORY')"
  id="trans_hist_search"
  class="card card-nc"
>
  <div class="card-heading">
    <div class="row">
      <div class="col-md-4">
        <span class="icon-NC_history"></span>
        <span class="transactionHistHeader"> TRANSACTION HISTORY SEARCH </span>
      </div>
      <!-- /input-group -->
      <div class="col-md-4">
        <div class="input-group datepicker dtpicker-btn inline">
          <label for="startDate" class="labelCommon">START DATE</label>
          <input
            id="tranMinDate"
            name="startDate"
            readonly="readonly"
            class="form-control"
            [ngModel]="startDate"
            (ngModelChange)="startDate = $event"
            (dateSelect)="refreshVisitorCardTransactionData()"
            [maxDate]="endDate"
            #dp="ngbDatepicker"
            ngbDatepicker
            (click)="dp.toggle()"
          />
          <div class="input-group-append">
            <button
              type="button"
              class="fa fa-calendar"
              (click)="dp.toggle()"
            ></button>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="input-group datepicker dtpicker-btn inline">
          <label for="endDate" class="labelCommon">END DATE</label>
          <input
            id="tranMaxDate"
            name="endDate"
            readonly="readonly"
            class="form-control"
            [ngModel]="endDate"
            (ngModelChange)="endDate = $event"
            [minDate]="startDate"
            (dateSelect)="refreshVisitorCardTransactionData()"
            #dp2="ngbDatepicker"
            ngbDatepicker
            (click)="dp2.toggle()"
          />
          <div class="input-group-append">
            <button
              type="button"
              class="fa fa-calendar"
              (click)="dp2.toggle()"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body zeroPadding">
    <div
      class="table-responsive"
      *ngIf="hasEntitlement('VISITORS_ACCOUNTS_HISTORY')"
    >
      <table
        class="table tableBackground tableRow table-bordered table-hover zeroPadding"
      >
        <thead class="transactionHistHeader tableheading">
          <tr>
            <th class="text-center col-2">DATE</th>
            <th class="text-center col-2">POSTED</th>
            <th class="text-center col-1">TYPE</th>
            <th class="text-center col-3">DESCRIPTION</th>
            <th class="text-center col-2">AMOUNT</th>
            <th class="text-center col-2">BALANCE</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="dataLoading">
            <td colspan="7" style="text-align: center; height: 150px;">
              <i class="fa fa-spinner fa-2x fa-pulse"></i>
            </td>
          </tr>
          <tr *ngIf="expandedTransactions.length === 0 && !dataLoading">
            <td colspan="7" style="text-align: center; height: 150px;">
              No account activity found.
            </td>
          </tr>
          <ng-container *ngFor="let transaction of expandedTransactions">
            <tr>
              <td class="transactionHistText text-center col-2">
                {{ transaction.tran.date | date: 'mediumDate' }}
              </td>
              <!-- pattern="MM/dd/yyyy" -->
              <td class="transactionHistText text-center col-2">
                {{ transaction.tran.postDate | date: 'mediumDate' }}
              </td>
              <td>
                Chip
              </td>
              <td class="transactionHistText text-left col-4">
                {{ transaction.tran.descr }}
                <span
                  style="float: right;"
                  *ngIf="transaction.tran.reverseState === -1"
                  [ngClass]="{
                    greenBackGround: transaction.tran.amount >= 0.0,
                    redBackGround: transaction.tran.amount < 0.0
                  }"
                  >R</span
                >
              </td>
              <td
                class="text-center col-2"
                [ngClass]="{
                  'text-success': transaction.tran.amount >= 0.0,
                  'text-fail': transaction.tran.amount < 0.0
                }"
              >
                {{ transaction.tran.amount | currency | minusSignToParens }}
              </td>
              <td
                class="text-center col-2"
                [ngClass]="{
                  'text-success': transaction.tran.balance >= 0.0,
                  'text-fail': transaction.tran.balance < 0.0
                }"
              >
                {{ transaction.tran.balance | currency | minusSignToParens }}
              </td>

              <td>
                <a
                  ><i
                    *ngIf="!transaction.expanded"
                    class="fa fa-plus-square"
                    (click)="
                      transaction.expanded = true;
                      getTransactionDetails(transaction)
                    "
                  ></i>
                  <i
                    *ngIf="transaction.expanded"
                    class="fa fa-minus-square"
                    (click)="
                      transaction.expanded = false; transaction.tranDetails = []
                    "
                  ></i>
                </a>
              </td>
            </tr>
            <tr *ngIf="transaction.expanded === true">
              <td colspan="5">
                <div *ngFor="let trans of transaction.tranDetails | keyvalue">
                  <span class="transactionHistText"
                    ><strong>{{ trans.key }}</strong
                    >&nbsp;{{ trans.value }}</span
                  >
                </div>
              </td>
              <td
                colspan="4"
                *ngIf="transaction.tran.reverseState === -1"
                class="reverseSection"
              >
                Has Been Reversed
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
